import React from 'react'
import styled from 'styled-components'
import extractColor from '../helpers/extract-color'

Hero = ({card, color})->
	<Wrapper color={color} backgroundImage={card.background}>
		<InnerWrapper headingColor={card.headingColor}>
			<Photo>
				<PhotoImage src={card.photo} />
			</Photo>
			<Name>{card.name}</Name>
			<Position>{card.position}</Position>
			{if card.company
				<Company>{card.company}</Company>
			}
		</InnerWrapper>
	</Wrapper>


Wrapper = styled.div"""
	overflow: hidden
	position: relative
	z-index: 3
	border-bottom: 1px solid #d9dadc
	color: #141414
	#{({color, backgroundImage})->
		if backgroundImage then """
			background-image: url(#{backgroundImage});
			background-repeat: no-repeat;
			background-position: 50% 50%;
			background-size: cover;
		""" else
			{gradient, direction} = extractColor(color)
			"background: linear-gradient(#{direction.replace('90deg','45deg')}, #{gradient[0]}, #{gradient[1]})"
	}
"""

InnerWrapper = styled.div"""
	box-sizing: border-box
	position: relative
	z-index: 3
	max-width: 1170px
	height: 100%
	margin: 0 auto;
	padding: 60px 20px 40px;
	text-align: center
	color: #{({headingColor='light'})->
		if headingColor is 'light'
			return 'white'
		else
			return '#141414'
	}
"""

Photo = styled.div"""
	position: relative
	box-sizing: border-box
	width: 109px
	height: 109px
	margin: 0 auto;
	margin-bottom: 14px
	border-radius: 50%
	border: 5px solid rgba(255,255,255,0.23);
	overflow: hidden
"""

PhotoImage = styled.img"""
	width: 100%
	height: 100%
	object-fit: cover
	object-position: center
"""

Name = styled.div"""
	font-size: 30px
	font-weight: 600
	line-height: 1em
	letter-spacing: #{-20/1e3}em
"""

Position = styled.div"""
	margin-top: 10px
	font-weight: 400
	line-height: 1.38em
	font-family: gotham
	font-size: 12px
	text-transform: uppercase
	letter-spacing: #{40/1e3}em
"""

Company = styled.div"""
	margin-top: 5px
	font-weight: 500
	line-height: 1.38em
	font-size: 11px
	letter-spacing: #{20/1e3}em
	opacity: 0.55
"""



export default Hero